import { connectUser } from "./autoLogin.js";
let api;
let user;
/**
 * @description Initialise le plugin en ajoutant l'intercepteur à axios
 * @author Félix Bordage
 * @param {Object} apiRequetes - Objet représentant l'api
 * @param {Object} userVue - Objet de l'utilisateur provenant du Vue. nécessaire pour
 * déconnecter l'utilisateur si le refresh_token devient invalide
 */
export function addInterceptExpiredAccessToken(apiRequetes, userVue) {
  api = apiRequetes;
  user = userVue;
  api.axios.interceptors.response.use(null, interceptExpiredAccessToken);
}
let watchedRequests = [];

/**
 * @description Intercepte le cas où le Access Token n'est plus valide et
 * tente de le rafraîchir
 * @author Félix Bordage
 * @param {Error} error - Erreur lancée par axios lors d'une requête échouée
 */
async function interceptExpiredAccessToken(error) {
  if (
    error.response.status === 401 &&
    api.axios.defaults.headers.common.Authorization != null
  ) {
    if (!watchedRequests.includes(error.response.config.url)) {
      watchedRequests.push(error.response.config.url);
      // Tente de reconnecter
      user.set(await connectUser(api));
      // Si la connexion échoue, on sait d'avance que la requête va échouer
      if (user.get().role == "guest") {
        return Promise.reject(error);
      }
      error.config.headers.Authorization =
        api.axios.defaults.headers.common.Authorization;
      try {
        let reponse = await api.axios.request(error.config);
        removeWatched(error.response.config.url);
        return reponse;
      } catch {
        removeWatched(error.response.config.url);
        return Promise.reject(error);
      }
    }
  }
  return Promise.reject(error);
}

/**
 * @description Enlève une requête de la liste des requêtes en traitement
 * @author Félix Bordage
 * @param {String} request - url de la requête
 */
function removeWatched(request) {
  watchedRequests.splice(watchedRequests.indexOf(request), 1);
}
